import { connectorAssetsApi, connectorDetailApi } from "../api";

export const connectorDetailService = {
  get: async (connectionId: string) => await connectorDetailApi.get(connectionId),

  updateConnectionStatus: async (
    connectionId: string,
    status: "connected" | "disconnected",
  ) => await connectorDetailApi.patchStatus(connectionId, { status }),

  /** Bulk-selects assets (sets `is_selected=true`). */
  patchAssetSelection: async (
    catalogKey: string,
    assetIds: string[],
  ): Promise<void> => {
    await connectorAssetsApi.bulkSelect(catalogKey, assetIds);
  },
};
